import axios from "axios";
import { BASE_URL } from "../clientConfig";
import { getLocalStorage, setLocalStorage } from "../utils";
import { LOCAL_STORAGE_KEYS } from "../constants";
import { ADMIN_AUTH_ROUTES } from "../constants/adminApiRoutes";
import {
  ADMIN_ROUTES,
  AGENT_ROUTES,
  BUILDER_ROUTES,
} from "../constants/appRoutes";

const API = axios.create({
  baseURL: BASE_URL,
});

API.interceptors.request.use(
  (config) => {
    const token = getLocalStorage(LOCAL_STORAGE_KEYS.ACCESS_TOKEN);

    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    if (!config.headers["Content-Type"]) {
      config.headers["Content-Type"] = "application/json";
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

API.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (
      error?.response?.status === 401 &&
      originalRequest?.url === `${BASE_URL}${ADMIN_AUTH_ROUTES.REFRESH_TOKEN}`
    ) {
      // window.location.href = ADMIN_ROUTES.LOGIN;
      const currentPath = window.location.pathname;

      if (
        currentPath.startsWith(ADMIN_ROUTES.ROOT) ||
        currentPath.startsWith(AGENT_ROUTES.ROOT) ||
        currentPath.startsWith(BUILDER_ROUTES.ROOT)
      ) {
        window.location.href = ADMIN_ROUTES.LOGIN;
      } else {
        window.location.href = "/";
      }
      return Promise.reject(error);
    }

    if (error?.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = getLocalStorage(LOCAL_STORAGE_KEYS.REFRESH_TOKEN);

      if (!refreshToken) {
        window.location.href = ADMIN_ROUTES.LOGIN;
        return Promise.reject(error);
      }

      try {
        const res = await axios.post(
          `${BASE_URL}${ADMIN_AUTH_ROUTES.REFRESH_TOKEN}`,
          { refreshToken },
          { withCredentials: true }
        );

        if (res.status === 200) {
          const newAccessToken = res?.data?.data?.token;
          const newRefreshToken = res?.data?.data?.refreshToken;

          setLocalStorage(LOCAL_STORAGE_KEYS.ACCESS_TOKEN, newAccessToken);
          setLocalStorage(LOCAL_STORAGE_KEYS.REFRESH_TOKEN, newRefreshToken);

          originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;

          return API(originalRequest);
        }
      } catch (refreshError) {
        window.location.href = ADMIN_ROUTES.LOGIN;
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default API;
